import React from 'react';

const Hero = () => {
  const backgroundImageUrl =
    'https://cdn.speedsize.com/eb8d0010-7300-4129-8a6d-74bc221f9caf/https://www.virginvoyages.com/dam/jcr:e38c13f7-b218-4102-9ce1-a35d4d243ba9/FM_CMI_VVcom_1600x700.jpg';

  return (
    <section
      className="relative bg-white min-h-screen"
      aria-label="Virgin Voyages Cruise Experience"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ backgroundImage: `url('${backgroundImageUrl}')` }}
        role="img"
        aria-label="Virgin Voyages Scarlet Lady"
      ></div>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
        <div className="flex flex-col lg:flex-row items-start gap-8">
          {/* Hero Text Section */}
          <div className="lg:w-3/4 mx-auto bg-white bg-opacity-90 p-12 rounded-lg shadow-lg text-center">
            <h1 className="text-6xl font-bold text-gray-900 mb-8">
              Set Sail with Virgin Voyages
            </h1>
            <p className="text-2xl text-gray-700 mb-8">
              Experience luxury at sea like never before aboard the stunning Scarlet Lady. Adult-by-Design cruising with exceptional dining, immersive entertainment, and world-class service.
            </p>
            <p className="text-2xl text-gray-700 mb-8">
              Join us for unforgettable journeys through the Caribbean, featuring curated itineraries and vibrant destinations that will ignite your sense of adventure.
            </p>
            {/* Video Section */}
            <div className="lg:w-3/4 mx-auto">
              <video
                className="w-full h-auto rounded-lg shadow-lg"
                autoPlay
                loop
                muted={true}
                controls
                playsInline
                onCanPlay={(e) => {
                  e.target.muted = false;
                  e.target.play();
                }}
              >
                <source src="/Virgin Voyages - Karma TV Spot US_30s_CTA.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;